<ng-container *ngIf="config">
  <mat-table
    *ngrxLet="breakpoint$ as breakpoint"
    matSort
    multiTemplateDataRows
    [seperation]="separation"
    [dataSource]="dataSource"
    [matSortActive]="config.sort.active"
    [matSortDirection]="config.sort.direction"
    class="dynamic-table__table"
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef class="flex-initial">
        <mat-checkbox
          (change)="$event ? toggleAllRowSelections() : null"
          [checked]="selectionModel.hasValue() && isAllSelected"
          [indeterminate]="selectionModel.hasValue() && !isAllSelected"
          class="checkbox-fix"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-initial">
        <ng-container *ngIf="viewReady">
          <div>
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selectionModel.toggle(row) : null"
              [checked]="selectionModel.isSelected(row)"
              class="checkbox-fix"
            >
            </mat-checkbox>
          </div>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container *ngFor="let column of columns" [matColumnDef]="column.id">
      <mat-header-cell
        *matHeaderCellDef
        [mat-sort-header]="column.props?.path"
        [disabled]="!$any(column).sortable"
        [ngStyle]="
          column.layout
            ? {
                flex:
                  column.layout[breakpoint]?.flex ||
                  column.layout['DEFAULT']?.flex ||
                  '0 1 auto',
                order:
                  column.layout[breakpoint]?.order ||
                  column.layout['DEFAULT']?.order ||
                  0
              }
            : { flex: '0 1 auto', order: 0 }
        "
        [class]="column.classNames"
      >
        {{ column.label }}
      </mat-header-cell>

      <mat-cell
        *matCellDef="let row"
        [attr.data-label]="column.label"
        [ngStyle]="
          column.layout
            ? {
                flex:
                  column.layout[breakpoint]?.flex ||
                  column.layout['DEFAULT']?.flex ||
                  '0 1 auto',
                order:
                  column.layout[breakpoint]?.order ||
                  column.layout['DEFAULT']?.order ||
                  0
              }
            : { flex: '0 1 auto', order: 0 }
        "
        [class]="column.classNames"
        [class.hide-label]="
          column.layout ? column.layout[breakpoint]?.hideLabel : false
        "
      >
        <ng-container *ngIf="viewReady">
          <ng-container
            *ngrxLet="row[column.id] as cell"
            [ngSwitch]="column.type"
          >
            <la-dynamic-table-context-menu
              *ngSwitchCase="columnTypes.Context"
              [entity]="row"
              [props]="column.props"
              [additionalData]="additionalData || {}"
              [isOpen]="activeRow === row.id || activeRowContext === row.id"
              (contextChanged)="activeRowContext = $event"
              (childOutput)="
                customEvent.emit({
                  id: $event.id,
                  entity: row,
                  event: $event.event
                })
              "
            >
            </la-dynamic-table-context-menu>

            <ndc-dynamic
              *ngSwitchCase="columnTypes.Template"
              [ndcDynamicComponent]="column.template"
              [ndcDynamicInputs]="{
                entity: row,
                props: column.props,
                focused: activeRow === row.id || activeRowContext === row.id,
                additionalData: additionalData
              }"
            ></ndc-dynamic>

            <span *ngSwitchDefault>{{ row[column.id] || '-' }}</span>
          </ng-container>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expansionDetails">
      <mat-cell *matCellDef="let row" class="d-block flex-1">
        <ng-container *ngIf="viewReady">
          <div *ngIf="expandedElement === row.id" [@expansion]>
            <ndc-dynamic
              [ndcDynamicComponent]="config.expansion?.column?.template"
              [ndcDynamicInputs]="{
                entity: row,
                props: config.expansion?.column?.props,
                focused: activeRow === row.id || activeRowContext === row.id,
                additionalData: additionalData
              }"
            ></ndc-dynamic>
          </div>
        </ng-container>
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="columnsToDisplay"
      class="dynamic-table__row flex-wrap"
    ></mat-header-row>

    <mat-row
      *matRowDef="let row; dataIndex as index; columns: columnsToDisplay"
      [ngClass]="{
        clickable: row._meta?.clickable,
        active: activeRow === row.id || activeRowContext === row.id,
        alt: !(index % 2)
      }"
      (mouseenter)="activeRow = row.id"
      (mouseleave)="activeRow = undefined"
      (focus)="activeRow = row.id"
      (blur)="activeRow = undefined"
      (click)="onRowClicked(row)"
      class="dynamic-table__row flex-wrap"
      tabindex="0"
      [id]="'row-' + getRowId(row)"
    ></mat-row>

    <mat-row
      *matRowDef="let element; columns: ['expansionDetails']"
      class="dynamic-table__row d-flex expandable"
    ></mat-row>

    <div *matNoDataRow class="p-2 text-center">
      <span *ngIf="!isLoading; else loadingTmpl">{{ noDataMessage }}</span>
    </div>
  </mat-table>

  <mat-paginator
    class="mt-2"
    [class.d-none]="
      !config.pagination.paginatable ||
      dataSource.data.length <= config.pagination.size
    "
    [pageSize]="config.pagination.size"
    [pageSizeOptions]="config.pagination.options"
    [showFirstLastButtons]="config.pagination.showEdgeButtons"
  ></mat-paginator>

  <ng-template #textTmpl let-text>
    <span>{{ text }}</span>
  </ng-template>

  <ng-template #loadingTmpl>
    <div class="vstack gap-8">
      <lui-skeleton
        *ngFor="let n of 5 | timesWith"
        [height]="64"
      ></lui-skeleton>
    </div>
  </ng-template>
</ng-container>
